export default "__VITE_ASSET__CifI7Al___"